import React from 'react'
import { Row, Col, Button } from 'antd'
import { IconHelper, routersHelper } from '../../helpers'

const Footer = props => {
    const { setCamera, isOpenCamera, isOpenMicrophone, setMicrophone } = props
    const { useRouter } = routersHelper
    const router = useRouter()

    const handleCamera = isOpen => {
        setCamera(!isOpen)
    }
    const hanndleMicrophone = isOpen => {
        setMicrophone(!isOpen)
    }
    const handleButton = (route, isOpenCamera, isOpenMicrophone) => {
        const startWithAudioMuted = !isOpenMicrophone
        const startWithVideoMuted = !isOpenCamera
        const roomName = route
        window.location = `https://vroom.truevirtualworld.com/${roomName}#config.startWithAudioMuted=${startWithAudioMuted}&config.startWithVideoMuted=${startWithVideoMuted}`
    }

    const { IconMicON, IconMicOff, IconCameraOn, IconCameraOff } = IconHelper

    return (
        <Row className="camera-footer">
            <Col span={24}>
                <div>
                    [Demo-Name]
                    </div>
                <div>
                    {
                        isOpenMicrophone ? (
                            <IconMicOff
                                onClick={() => hanndleMicrophone(isOpenMicrophone)}
                            />
                        ) : (
                                <IconMicON
                                    onClick={() => hanndleMicrophone(isOpenMicrophone)}
                                />
                            )
                    }
                    {
                        isOpenCamera ? (
                            <IconCameraOff
                                onClick={() => handleCamera(isOpenCamera)}
                            />
                        ) : (
                                <IconCameraOn
                                    onClick={() => handleCamera(isOpenCamera)}
                                />
                            )
                    }
                </div>
                <Row type="flex" justify="center" align="middle">
                    <Col lg={5} md={10} sm={12} xs={12}>
                        <Button type="primary" danger onClick={() => handleButton(router.query.roomName, isOpenCamera, isOpenMicrophone)}>
                            JOIN MEETING
                            </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default Footer